import { Component, ReactNode } from "react"

export interface ModalProps {
    isOpen: boolean
    isLoginForm?: boolean
}

class ModalWaith extends Component<ModalProps> {

    componentDidUpdate(prevProps: Readonly<ModalProps>, prevState: Readonly<{}>, snapshot?: any): void {
        let targetElement = document.querySelector(".wait-modal")

        if (this.props.isOpen) {    
            document.querySelector("body")?.classList.add("no-vertical-scrool")
            targetElement?.scrollIntoView( { behavior: 'smooth', block: 'start' } )
        }
        else {
            document.querySelector("body")?.classList.remove("no-vertical-scrool")
        }
    }

    render(): ReactNode {

        return (
            (this.props.isOpen) &&
            <div className="modal-container">
                <div className="modal-fade-show wait-modal" tabIndex={-1}>
                    <div className='modal-dialog modal-dialog-centered modal-lg modal-waith'>
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="modal-title titleLev4 colorPrimaryBlue mb-2">
                                    Un attimino...
                                </span>
                            </div>
                            <div className="modal-body">
                                {
                                    (this.props.isLoginForm)
                                        ? <>Stiamo verificando i tuoi dati</>
                                        : <>Stiamo salvando i tuoi dati</>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-fade-backdrop"></div>
            </div>
        )

    }
}

export default ModalWaith